import React from 'react';
import { Text } from '@plug/ui';
import { Box } from 'rebass';

import isDesktop from '@plug/helpers/is-desktop';

type OnboardingContentHeaderProps = {
  title: string | React.ReactNode;
  subtitle: string | React.ReactNode;
};
const OnboardingContentHeader: React.FC<OnboardingContentHeaderProps> = ({ title, subtitle }) => (
  <Box pb={isDesktop ? '48px' : '28px'} sx={{ textAlign: 'center' }}>
    <Text fontSize={isDesktop ? '32px' : '24px'} color="#1C1637" fontWeight="bold" pb="24px">
      {title}
    </Text>
    <Text color="#666372" fontSize={isDesktop ? '16px' : '12px'} fontWeight="500">
      {subtitle}
    </Text>
  </Box>
);

export default OnboardingContentHeader;
